<script>
/**
 * Descripción: Componente TheArticles the la aplicación
 *
 * @displayName TheArticles
 */

const BaseFeed = () =>
  import(
    /* webpackChunkName: "BlogViewComponent" */ '@/components/core/forms/BaseFeed'
  );

export default {
  name: 'TheArticles',

  components: {
    BaseFeed
  }
};
</script>

<template>
  <section id="feed">
    <BaseFeed>
      <slot />
    </BaseFeed>
  </section>
</template>
